import { Dayjs } from 'dayjs';
import dayjs from './dayjsSetup';

const isEndOfYear = (date: Dayjs): boolean => {
  return dayjs(date).isSame(dayjs(date).endOf('year'), 'day');
};

export default isEndOfYear;
